var render = function render(){var _vm=this,_c=_vm._self._c;return _c('unicom-linha',[_c('unicom-coluna',{attrs:{"sm":"12"}},[_c('TabelaEndereco',{attrs:{"idRnpPrestador":_vm.idRnpPrestador}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }